export default __webpack_public_path__ + "static/media/itsme.aa4c64a2.svg";